import {Route, Switch} from "react-router-dom";
import Home from "../../home/Home";
import Login from "../../auth/Login";
import Register from "../../auth/Register";
import Dashboard from "../../dashboard/Dashboard";
import Profile from "../../dashboard/Profile";
import ChangePassword from "../../dashboard/ChangePassword";
import ActiveAppointments from "../../dashboard/ActiveAppointments";
import PastAppointments from "../../dashboard/PastAppointments";

export default function Navigation() {
    return (<Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/auth/login" component={Login}/>
        <Route exact path="/auth/register" component={Register}/>
        <Route exact path="/user/dashboard" component={Dashboard}/>
        <Route exact path="/user/profile" component={Profile}/>
        <Route exact path="/user/change-password" component={ChangePassword}/>
        <Route exact path="/user/active-appointments" component={ActiveAppointments}/>
        <Route exact path="/user/past-appointments" component={PastAppointments}/>
    </Switch>)
}
